
import { Creative } from '../types';

/**
 * Save creatives to localStorage
 */
export const saveCreativesToStorage = (
  creatives: Creative[],
  locationCreatives: Record<string, Creative[]>,
  mediaOwnerCreatives: Record<string, Creative[]>,
  useMediaOwnerSpecificCreatives: boolean
): void => {
  // Collect all creative URLs for master list
  const allCreativeUrls: string[] = [];
  
  // Save general creatives
  const creativeUrls = creatives.map(creative => creative.url);
  localStorage.setItem('creativeUrls', JSON.stringify(creativeUrls));
  
  // Add general creatives to master list
  creatives.forEach(creative => {
    if (creative.url && !allCreativeUrls.includes(creative.url)) {
      allCreativeUrls.push(creative.url);
    }
  });
  
  // Save all location-specific creatives
  localStorage.setItem('locationCreatives', JSON.stringify(locationCreatives));
  
  // Add location-specific creatives to master list
  Object.values(locationCreatives).forEach(locCreatives => {
    locCreatives.forEach(creative => {
      if (creative.url && !allCreativeUrls.includes(creative.url)) {
        allCreativeUrls.push(creative.url);
      }
    });
  });
  
  // Save all media owner-specific creatives
  localStorage.setItem('mediaOwnerCreatives', JSON.stringify(mediaOwnerCreatives));
  
  // If media owner specific creatives are enabled, save those URLs by media owner
  if (useMediaOwnerSpecificCreatives && Object.keys(mediaOwnerCreatives).length > 0) {
    const mediaOwnerCreativeUrls: Record<string, string[]> = {};
    
    Object.entries(mediaOwnerCreatives).forEach(([mediaOwnerName, ownerCreatives]) => {
      mediaOwnerCreativeUrls[mediaOwnerName] = ownerCreatives.map(creative => creative.url);
      
      // Add to master list
      ownerCreatives.forEach(creative => {
        if (creative.url && !allCreativeUrls.includes(creative.url)) {
          allCreativeUrls.push(creative.url);
        }
      });
    });
    
    localStorage.setItem('mediaOwnerCreativeUrls', JSON.stringify(mediaOwnerCreativeUrls));
  }
  
  // Save master list of all creative URLs
  localStorage.setItem('allCreativeUrls', JSON.stringify(allCreativeUrls));
  console.log(`Saved ${allCreativeUrls.length} total creative URLs to localStorage`);
};

/**
 * Save campaign name to localStorage
 */
export const saveCampaignName = (name: string): void => {
  localStorage.setItem('campaignName', name);
};

/**
 * Collect all creative URLs for completing the step
 */
export const collectAllCreativeUrls = (
  creatives: Creative[],
  mediaOwnerCreatives: Record<string, Creative[]>,
  locationCreatives: Record<string, Creative[]>,
  useMediaOwnerSpecificCreatives: boolean,
  useLocationSpecificCreatives: boolean
): string[] => {
  const allCreativeUrls: string[] = [];
  
  // Add general creatives
  creatives.forEach(creative => {
    if (creative.url && !allCreativeUrls.includes(creative.url)) {
      allCreativeUrls.push(creative.url);
    }
  });
  
  // Add media owner-specific creatives if enabled
  if (useMediaOwnerSpecificCreatives) {
    Object.values(mediaOwnerCreatives).forEach(ownerCreatives => {
      ownerCreatives.forEach(creative => {
        if (creative.url && !allCreativeUrls.includes(creative.url)) {
          allCreativeUrls.push(creative.url);
        }
      });
    });
  }
  
  // Add location-specific creatives if enabled
  if (useLocationSpecificCreatives) {
    Object.values(locationCreatives).forEach(locCreatives => {
      locCreatives.forEach(creative => {
        if (creative.url && !allCreativeUrls.includes(creative.url)) {
          allCreativeUrls.push(creative.url);
        }
      });
    });
  }
  
  return allCreativeUrls;
};
